import { takeEvery } from 'redux-saga/effects';
import { findGenerator } from 'helpers/resourceSagas';
import * as types from './types';
import * as api from './api';

export const findCurrent = findGenerator({
  resourceType: 'quickCycles',
  endpoint: api.findCurrent,
  endpointArgs: (payload) => [payload.subId],
  transformResponse: (resp, args) => {
    const usage = resp.data && resp.data.results && resp.data.results[0];
    return [{
      ...usage,
      id: args[0]
    }]
  },
});

export function* watchQuickCycles() {
  yield takeEvery(types.FIND_CURRENT, findCurrent);
}

